export default __webpack_public_path__ + "static/media/award delhi.35fc1da4.JPG";